module.exports = __webpack_public_path__ + "static/media/image-about-us-Desktop.77903854.png";